import React from "react";
import getLMColumns from "./columns";
import DataTable from './datatable/DataTable';

function LMTable({LMType, data, isLoading, onPaginationChange}) {
  return (
    <section className="data-table-wrapper relative-table-fixed ">
      <DataTable
        columns={getLMColumns(LMType)}
        data={data}
        isPaginationEnabled={true}
        customTable={true}
        isLoading={isLoading}
        onPaginationChange={onPaginationChange}
      />
    </section>
  );
}

LMTable.defaultProps = {
  LMType: '',
  data: [],
};


export default LMTable;